import {PostRefundCreateRequestResponse} from 'domain/usecases';
import {PostRefundCreateProcedureParams} from 'domain/usecases/private/refund/request/post-create-procedure';
import type {TherapyDataSchema} from '../components/AddTherapy/schemas/therapyDataSchema';

type ProcedureParamsBuilderProps = {
	currentProtocol: Omit<PostRefundCreateRequestResponse['content'], 'status' | 'message'>;
	currentTherapySession: TherapyDataSchema['sessions'][0];
	procedureCode?: string;
	specialtyCode?: string;
};

const procedureParamsBuilder = ({
	currentProtocol,
	currentTherapySession,
	procedureCode = '',
	specialtyCode = '',
}: ProcedureParamsBuilderProps): PostRefundCreateProcedureParams => ({
	sequentialProcedure: currentTherapySession?.id || '1',
	procedureCode,
	type: 'P', // "P" for "TERAPIAS"
	statisticsGroup: '',
	quantity: '1',
	serviceDate: currentTherapySession?.serviceDate || '',
	startTime: '',
	endTime: '',
	serviceTypeCode: '',
	procedureInformationValue: currentTherapySession?.sessionValue?.replaceAll('.', '') || '',
	reimbursement: '',
	procedurePrincipal: '',
	procedureAmount: currentTherapySession?.sessionValue?.replaceAll('.', '') || '',
	access: '',
	protocolDetail: {
		protocol: currentProtocol?.protocol || '',
		protocolCode: currentProtocol?.protocolCode.toString() || '',
		request: currentProtocol?.request || '',
		requestCode: currentProtocol?.requestCode.toString() || '',
	},
	specialty: {
		code: specialtyCode,
		specialPercentage: '',
	},
	coparticipation: {
		franchiseAmount: '',
		amount: '',
		discount: '',
	},
	service: {
		emergency: '',
		statusUti: '',
	},
});

export {procedureParamsBuilder};
